import { createContext } from "react";

const PunonjesitContext = createContext({});

export default PunonjesitContext;
